module.exports = __webpack_public_path__ + "assets/img/iconfont.bce063ea.svg";